import React from 'react';
import EditorHRule from '@wix/da-ds/pkg/Icons/24x24/EditorHRule';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const HRule = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (hideWhenNotEnabled && !isExtensionInstalled(editor, 'horizontalRuler')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: EditorHRule,
        onClick: ()=>editor.chain().focus().setHorizontalRule().run(),
        tooltipText: t('button.hr.tooltip'),
        "aria-label": t('button.hr.tooltip')
    });
};
HRule.displayName = 'HRule';
export default HRule;

//# sourceMappingURL=HRule.js.map